'use client';
import { mergeOptions } from './mergeOptions.js';
import { getDecoratedResponsePromise } from './core/getDecoratedResponsePromise.js';
import { requestMethods } from './domain/constants.js';

const createInstance = (defaults)=>{
    const client = (input, options)=>getDecoratedResponsePromise(input, mergeOptions(defaults, options));
    for (const method of requestMethods){
        client[method] = (input, options)=>getDecoratedResponsePromise(input, mergeOptions(defaults, options, {
                method
            }));
    }
    client.create = (newDefaults)=>createInstance(mergeOptions(newDefaults));
    client.extend = (newDefaults)=>createInstance(mergeOptions(defaults, newDefaults));
    return client;
};
var client = createInstance();

export { client as default };
//# sourceMappingURL=singleton.js.map
